import React, { useState, useEffect }  from "react";
import _ from 'lodash'
import { h } from '@app/helpers/translationHelper'

const indicies = Array.from(new Array(3), (x, i) => i + 1);

const Review = ({ number }) => {
  return (
    <div className="grid__item"
         dangerouslySetInnerHTML={ h(`landing.feedback.review_${number}`) }
         style={{ border: 'none' }}
    />
  )
}

const Reviews = () =>  {
  const perPage = 3;
  const totalPages = 5;
  const [start, setStart] = useState(0);
  const [page, setPage] = useState(0);

  const [userList, setUserList] = useState([]);

  const getUserList = (start, finish) => {
    setUserList([...userList, ...indicies.slice(start, finish)]);
  }

  const handleNewPage = () => {
    setPage(page + 1);
    setStart(start + perPage);
  }

  useEffect(() => {
    getUserList(start, start + perPage);
  }, [page]);

  return (
    <section className="section reviews" id="reviews">
      <h1 className="plate-heading plate-heading--left f--purple mb-1">
        { I18n.t('landing.feedback.heading') }
      </h1>

      <div className="grid grid--xl-3">
        { _.map(userList, (x, i) => <Review key={i} number={x} />) }
      </div>
    </section>
  );
}

export default Reviews
